export const TILE_SIZE = 30;
export const BASE_TILE_TEXTURE_SPAN = 8;

export const TILE_KIND_BASE = 'baseTile';
export const TILE_KIND_DETAIL = 'detail';

// Earlier terrain textures feather into later terrain textures at shared edges.
export const BASE_TILE_TRANSITION_ORDER = [
  'sand',
  'wetSand',
  'shallowWater',
  'middleWater',
  'deepWater',
  'cliff',
];

export const TILE_TYPES = {
  sand: {
    id: 'sand',
    label: 'Dry Sand',
    walkable: true,
    type: TILE_KIND_BASE,
    fallbackColor: '#f2d18b',
  },
  wetSand: {
    id: 'wetSand',
    label: 'Wet Sand',
    walkable: true,
    type: TILE_KIND_BASE,
    fallbackColor: '#d8b170',
  },
  shallowWater: {
    id: 'shallowWater',
    label: 'Shallow Water',
    walkable: false,
    type: TILE_KIND_BASE,
    fallbackColor: '#52c4dd',
  },
  middleWater: {
    id: 'middleWater',
    label: 'Middle Water',
    walkable: false,
    type: TILE_KIND_BASE,
    fallbackColor: '#3894b8',
  },
  deepWater: {
    id: 'deepWater',
    label: 'Deep Water',
    walkable: false,
    type: TILE_KIND_BASE,
    fallbackColor: '#1d5f9b',
  },
  cliff: {
    id: 'cliff',
    label: 'Cliff',
    walkable: false,
    type: TILE_KIND_BASE,
    fallbackColor: '#8b7765',
  },
};

export const DETAIL_TYPES = {
  palm: {
    id: 'palm',
    label: 'Palm Tree',
    type: TILE_KIND_DETAIL,
    fallbackColor: '#2f9a57',
  },
  rock: {
    id: 'rock',
    label: 'Rock',
    type: TILE_KIND_DETAIL,
    fallbackColor: '#8a8f99',
  },
  shells: {
    id: 'shells',
    label: 'Shells',
    type: TILE_KIND_DETAIL,
    fallbackColor: '#fef0d1',
  },
};

export function resolveTileType(id) {
  return TILE_TYPES[id] || TILE_TYPES.sand;
}

export function resolveDetailType(id) {
  if (!id) return null;
  return DETAIL_TYPES[id] || null;
}

export function createDefaultMap(width = 100, height = 100) {
  const tiles = [];
  for (let y = 0; y < height; y += 1) {
    const row = [];
    for (let x = 0; x < width; x += 1) {
      let base = 'sand';
      if (y > height - 10) {
        base = 'deepWater';
      } else if (y > height - 15) {
        base = 'shallowWater';
      } else if (y > height - 18) {
        base = 'wetSand';
      }

      if (x < 5) {
        base = 'cliff';
      }

      let detail = null;
      if (base === 'sand' && Math.random() < 0.02) {
        detail = 'palm';
      } else if (base === 'wetSand' && Math.random() < 0.03) {
        detail = 'shells';
      } else if (base === 'cliff' && Math.random() < 0.04) {
        detail = 'rock';
      }

      row.push({ base, detail });
    }
    tiles.push(row);
  }

  return { width, height, tiles };
}
